module.exports = __webpack_public_path__ + "static/367117_0_0-5c89d3c376802f1dda729fb1101b417a.ttf";